import { ref, provide, inject } from 'vue'

export function useRowModelType(initialType = 'clientSide') {
  const rowModelType = ref(initialType)

  const setRowModelType = (value) => {
    if (!['clientSide', 'serverSide'].includes(value)) {
      console.warn(`Invalid rowModelType: ${value}. Must be 'clientSide' or 'serverSide'.`)
      return
    }
    rowModelType.value = value
  }

  setRowModelType(initialType)

  provide('rowModelType', rowModelType)

  return {
    rowModelType,
    setRowModelType,
  }
}

export function injectRowModelType() {
  const rowModelType = inject('rowModelType')
  if (!rowModelType) console.warn('rowModelType not provided. Ensure useRowModelType is called in an ancestor component.')

  return rowModelType || ref('clientSide')
}
